<template>
  <div>
    <div v-for="item in items">
      <slot name="item" v-bind="item"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ks-div',
  props:  {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {

  }
}
</script>
